import { email, social } from '../config/site.js';

export default function Contact() {
  return (
    <section className="page-content">
      {/* <h1><em>Contact</em></h1> */}
      {/* <hr /> */}
      <p>Find us online and join the conversation:</p>
      <ul>
        {social.map(({ label, url }) => (
          <li key={label}>
            <a href={url} target="_blank" rel="noreferrer">{label}</a>
          </li>
        ))}
        <li>
          <a href={`mailto:${email}`}>{email}</a>
        </li>
      </ul>
      <p style={{ marginTop: '1.5rem' }}>
        For collaborations, press inquiries, or just to say hello — drop us a line anytime.
      </p>
    </section>
  );
}
